<app-header [progress]="3" [title]="locale.currentTranslation.tripInformationHeader" data-testid="third-party-contact-header"></app-header>
<div class="base-content-container" data-testid="third-party-contact-container">
  <div class="headline3" data-testid="third-party-contact-title">
    @if (isDriver) {
      {{ locale.currentTranslation.thirdPartyInformation1 }}
    } @else {
      {{ locale.currentTranslation.thirdPartyInformation2 }}
    }
  </div>
  <div class="display-column-gap-24" data-testid="third-party-form">
    <div class="display-column-gap-24" data-testid="third-party-list">
      @for (thirdParty of thirdPartyEntities; track thirdParty; let i = $index) {
        <div class="display-column-gap-24" [attr.data-testid]="'third-party-' + i">
          <div>
            <app-text-input
              [(value)]="thirdParty.surname"
              [placeholder]="locale.currentTranslation.witnessSurNamePlaceholder"
              [showError]="showMandatoryFieldError"
              [required]="true"
              [attr.data-testid]="'input-surname-' + i"
              [attr.aria-label]="locale.currentTranslation.witnessSurNamePlaceholder"
            ></app-text-input>
          </div>
          <div>
            <app-text-input
              [(value)]="thirdParty.name"
              [placeholder]="locale.currentTranslation.witnessNamePlaceholder"
              [showError]="showMandatoryFieldError"
              [required]="true"
              [attr.data-testid]="'input-name-' + i"
              [attr.aria-label]="locale.currentTranslation.witnessNamePlaceholder"
            ></app-text-input>
          </div>
          <div>
            <app-text-input
              [type]="'tel'"
              [(value)]="thirdParty.phone"
              [placeholder]="locale.currentTranslation.witnessPhonePlaceholder"
              [showError]="showMandatoryFieldError"
              [required]="true"
              [attr.data-testid]="'input-phone-' + i"
              [attr.aria-label]="locale.currentTranslation.witnessPhonePlaceholder"
            ></app-text-input>
          </div>
          <div>
            <app-text-input
              [type]="'email'"
              [(value)]="thirdParty.email"
              [placeholder]="locale.currentTranslation.witnessEmailPlaceholder"
              [showError]="showMandatoryFieldError"
              [required]="false"
              [attr.data-testid]="'input-email-' + i"
              [attr.aria-label]="locale.currentTranslation.witnessEmailPlaceholder"
            ></app-text-input>
          </div>
          @if (i < thirdPartyEntities.length -1) {
            <div class="divider"></div>
          }
        </div>
      }
    </div>
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
  @if (showMandatoryFieldError) {
    <div class="caption1 error-text" data-testid="mandatory-fields-error" role="alert">
      {{ locale.currentTranslation.errorMessageMandatoryFieldsMissing }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="third-party-contact-footer"></app-footer>
